let mainStyles = [...Array(13).keys()].map((item)=>{
    return {
        label: `Stil ${item + 1}`,
        value: `style-${item}`
    }
})

//     [
//     {
//         label: 'Stil 1',
//         value: 'style-1'
//     },
//     {
//         label: 'Stil 2',
//         value: 'style-2'
//     },
//     {
//         label: 'Stil 3',
//         value: 'style-3'
//     },
//     {
//         label: 'Stil 4',
//         value: 'style-4'
//     },
//     {
//         label: 'Stil 5',
//         value: 'style-5'
//     },
//     {
//         label: 'Stil 6',
//         value: 'style-6'
//     },
// ]

export default {
    mainStyles,
    layoutOptions: [
        {
            label: 'Stående',
            value: 'vertical'
        },
        {
            label: 'Liggande',
            value: 'horizontal'
        }
    ],
    sizeOptions: [
        // {
        //     label: 'A4',
        //     value: 'a4',
        // },
        // {
        //     label: '30x40cm',
        //     value: '30x40cm',
        // },
        {
            label: '50x70cm',
            value: '50x70cm',
        },
    ],
}
